var exports = {
  "dc": "CosmeticsSettingsTab.module__spinnerContainer___NVhVdl",
  "Zp": "CosmeticsSettingsTab.module__layout___NVhVdl",
  "U9": "CosmeticsSettingsTab.module__pickers___NVhVdl",
  "Bo": "CosmeticsSettingsTab.module__previewColumn___NVhVdl",
  "Vg": "CosmeticsSettingsTab.module__grid___NVhVdl",
  "QX": "CosmeticsSettingsTab.module__tileWrapper___NVhVdl",
  "Vs": "CosmeticsSettingsTab.module__tile___NVhVdl",
  "Q9": "CosmeticsSettingsTab.module__tileSelected___NVhVdl",
  "uP": "CosmeticsSettingsTab.module__tileImage___NVhVdl",
  "Wn": "CosmeticsSettingsTab.module__noneIcon___NVhVdl",
  "NE": "CosmeticsSettingsTab.module__lockBadge___NVhVdl",
  "Kl": "CosmeticsSettingsTab.module__tileName___NVhVdl",
  "Rj": "CosmeticsSettingsTab.module__lockedNotice___NVhVdl",
  "g5": "CosmeticsSettingsTab.module__lockedText___NVhVdl",
  "M4": "CosmeticsSettingsTab.module__nameplatePreview___NVhVdl",
  "WP": "CosmeticsSettingsTab.module__nameplateRow___NVhVdl",
  "to": "CosmeticsSettingsTab.module__nameplateName___NVhVdl",
  "Nz": "CosmeticsSettingsTab.module__picker___NVhVdl",
  "vw": "CosmeticsSettingsTab.module__seriesGroup___NVhVdl",
  "CF": "CosmeticsSettingsTab.module__seriesHead___NVhVdl",
  "NP": "CosmeticsSettingsTab.module__seriesCaret___NVhVdl",
  "LY": "CosmeticsSettingsTab.module__seriesCover___NVhVdl",
  "f_": "CosmeticsSettingsTab.module__seriesName___NVhVdl",
  "Lu": "CosmeticsSettingsTab.module__seriesCount___NVhVdl",
};

module.exports = exports;
